module.exports = __webpack_public_path__ + "static/media/covid_symptoms.1d71b8d9.svg";